import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { MessageType } from 'enums/MessageType';
import { DashboardElementModel } from 'models/generated/Identity.Api.Models.DashboardElement';
import { firstValueFrom } from 'rxjs';
import { PushService } from 'services/push.service';
import { UserService } from './user.service';

@Injectable()
export class DashboardService  {

	public ready = false;
	public onError = new EventEmitter<HttpErrorResponse>();

	private baseUrl = `${environment.gatewayUrl}/api/dashboard`;

	private dashboardElementsPromise?: Promise<DashboardElementModel[]>;

	constructor(private readonly http: HttpClient, private readonly pushService: PushService, private readonly userService: UserService) {
		this.pushService.onChanges(MessageType.DashboardChanges).subscribe(() => this.dashboardElementsPromise = undefined);
	}

	async getDashboardElements(): Promise<DashboardElementModel[]> {
		if (!this.dashboardElementsPromise) {
			this.dashboardElementsPromise = firstValueFrom(this.http.get<DashboardElementModel[]>(this.baseUrl));
		}
		return await this.dashboardElementsPromise;
	}

	createDashboardElement(dashboardElement: DashboardElementModel): Promise<DashboardElementModel> {
		dashboardElement.include(de => de.teamDashboardElements);
		dashboardElement.configurationMetaData = JSON.stringify(dashboardElement.configuration);
		return firstValueFrom(this.http.post<DashboardElementModel>(this.baseUrl, dashboardElement));
	}

	updateDashboardElement(dashboardElement: DashboardElementModel): Promise<DashboardElementModel> {
		dashboardElement.include(de => de.teamDashboardElements);
		dashboardElement.configurationMetaData = JSON.stringify(dashboardElement.configuration);
		return firstValueFrom(this.http.put<DashboardElementModel>(`${this.baseUrl}/${dashboardElement.id}`, dashboardElement));
	}

	deleteDashboardElement(dashboardElement: DashboardElementModel): Promise<void> {
		return firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${dashboardElement.id}`));
	}

}
